import React from "react";
import { BsTrash3 } from "react-icons/bs";
import "../style.scss"

import { Modal, Button } from "antd";

const DeleteComponent  = ({ open, setOpen, showModal, handleDelete, id }) => {
   const hideModal = () => {
      setOpen(false);
   };
   return (
      <>
            
         <Modal open={open} onOk={hideModal} okText="Yes" cancelText="No" className='workspace-modal' closable={false} width={600}>
            <div className="remove-modal d-flex flex-column align-content-center text-center">
               <p>
                  <span>
                     <BsTrash3 />
                  </span>
               </p>
               <h3 className="deleteHeading">Delete Item</h3>
               <p className="paragraphText">
                  Are you sure you want to delete this item? This action cannot be undone and
                  will delete all the data related to this item, including surveys, survey
                  submissions, labels, etc.
               </p>
            </div>
            <div className="delete-modal-button-group">
               <button onClick={hideModal} className="delete-modal-cancel">
                  No, keep it
               </button>
               <button onClick={() => {handleDelete(id); hideModal()}} className="yes-i-want-this">
                  Yes, delete it
               </button>
            </div>
         </Modal>
      
      </>
   );
};

export { DeleteComponent };
